import axios from '../utils/index';
import { Pat } from '@/typings/request';

/** Omit empty strings so Spring does not receive `startTime=` / `keyword=` etc. */
function listQueryParams(params?: Pat): Pat {
    if (!params) return {};
    const out: Pat = {};
    for (const key of Object.keys(params)) {
        const v = params[key];
        if (v !== '' && v !== undefined && v !== null) {
            out[key] = v;
        }
    }
    return out;
}

const taskerTemplateApi = {
    async getList(params?: Pat) {
        return axios.get(`/tasker-template/list`, { params: listQueryParams(params) });
    },
    async create(data: Pat) {
        return axios.post(`/tasker-template`, data);
    },
    async update(taskerTemplateId: string, data: Pat) {
        return axios.put(`/tasker-template/${taskerTemplateId}`, data);
    },
    async delete(taskerTemplateId: string) {
        return axios.delete(`/tasker-template/${taskerTemplateId}`);
    },
};

export default taskerTemplateApi;
